<table class="answers-table" [class.is-v3]="variant === 'v3'">
  <thead>
    <tr>
      <th></th>
      <th *ngFor="let c of columns; trackBy: trackCol" class="user" [class.recipient]="c.isRecipient">
        <img [src]="c.imageUrl || 'assets/profile_image.png'" alt="" />
        <div class="extra-small" [attr.title]="c.name">{{ c.name }}</div>
      </th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let r of rows; trackBy: trackRow" [class.highlight]="hasPicked(r)">
      <td class="medium bold">{{ r.label }}</td>
      <td *ngFor="let c of columns; trackBy: trackCol" class="cell" [class.recipient]="c.isRecipient">
        <mat-icon *ngIf="picked(r, c)" aria-hidden="true">check</mat-icon>
      </td>
    </tr>
  </tbody>
</table>
